import React from "react";
import styles from "./PricingCard.module.scss";

const PricingCard = ({ plan, isSuggested, isActivePlan, onSubscribe }) => {
    const cardStyle = isActivePlan ? styles.activePlanCardContainer :
        isSuggested ? styles.standardPlanCardContainer :
            styles.planCardContainer;

    const subscribeButtonStyle = isSuggested ? styles.standardSubscribeButton : styles.subscribeButton;

    return (
        <div className={cardStyle}>
            <h3 className={styles.planName}>{plan.name}</h3>
            <div className={styles.planPrice}>${plan.amount}</div>
            <ul className={styles.planFeatures}>
                {plan.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                ))}
            </ul>
            <button className={subscribeButtonStyle} onClick={onSubscribe}>
                { isActivePlan ? "Current Plan" : "Subscribe Now" }
            </button>
        </div>
    );
};

export { PricingCard };
